import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-upload-settings',
  templateUrl: './upload-settings.component.html',
  styleUrls: ['./upload-settings.component.css']
})
export class UploadSettingsComponent implements OnInit {

  api_error: any;
  api_success: string;
  acc_id: string;
  statusTo: string;
  disableConfirmbtn = false;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService,) { }

  ngOnInit() {
    console.log(this.data);
    this.acc_id = this.data.account.id;
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.accountService.uploadSettings(this.data.account.id)
    .subscribe(
      data => {
        this.api_success = 'Uploaded to S3 successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }
}